"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var attach_script_1 = tslib_1.__importDefault(require("../../../common/utils/attach-script"));
var url_1 = tslib_1.__importDefault(require("../../../common/utils/url"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var scriptApiUrl = 'https://www.youtube.com/iframe_api';
var apiPromise = null;
var YoutubeExternal = /** @class */ (function (_super) {
    tslib_1.__extends(YoutubeExternal, _super);
    function YoutubeExternal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleIframeRef = function (ref) {
            if (!ref) {
                return;
            }
            _this.iframeRef = ref;
            // TODO: replace with setting 'allow' attribute in jsx after migration to React 16
            ref.setAttribute('allow', 'autoplay');
            // if src is set before allow="autoplay", 'allow' has no effect
            ref.setAttribute('src', _this.buildUrl(_this.props));
            _this.props.onIframeRef(ref);
        };
        _this.onYouTubeIframeAPIReady = function () {
            new window.YT.Player(_this.iframeRef, {
                events: {
                    onReady: _this.onReady,
                    onStateChange: _this.onStateChange,
                },
            });
        };
        _this.onReady = function (_a) {
            var target = _a.target;
            _this.player = target;
            _this.setState({ isReady: true });
            _this.setSettings(_this.props);
        };
        _this.onStateChange = function (_a) {
            var data = _a.data;
            var _b = _this.props, onPlay = _b.onPlay, onPause = _b.onPause, onEnd = _b.onEnd;
            switch (data) {
                case window.YT.PlayerState.PLAYING:
                    onPlay();
                    break;
                case window.YT.PlayerState.PAUSED:
                    onPause();
                    break;
                case window.YT.PlayerState.ENDED:
                    onEnd();
                    break;
                default:
                    break;
            }
        };
        _this.onIframeLoaded = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!apiPromise) {
                            apiPromise = Promise.race([
                                new Promise(function (resolve) {
                                    window.onYouTubeIframeAPIReady = resolve;
                                }),
                                new Promise(function (resolve) {
                                    if (window.YT) {
                                        // somebody else already loaded api
                                        window.YT.ready(resolve);
                                    }
                                }),
                            ]);
                            (0, attach_script_1.default)(scriptApiUrl);
                        }
                        return [4 /*yield*/, apiPromise];
                    case 1:
                        _a.sent();
                        this.onYouTubeIframeAPIReady();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.player = null;
        _this.iframeRef = null;
        _this.state = {
            isReady: false,
        };
        return _this;
    }
    YoutubeExternal.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.src === this.props.src) {
            this.setSettings(nextProps, this.props);
        }
        else {
            this.setState({ isReady: false });
        }
    };
    YoutubeExternal.prototype.setSettings = function (_a, prevProps) {
        var isVideoPlayRequested = _a.isVideoPlayRequested, isVideoPauseRequested = _a.isVideoPauseRequested, loop = _a.loop, muted = _a.muted;
        if (prevProps === void 0) { prevProps = {}; }
        if (!this.player || !this.state.isReady) {
            return null;
        }
        if (prevProps.muted !== muted) {
            this.toggleMute(muted);
        }
        if (prevProps.isVideoPlayRequested !== isVideoPlayRequested &&
            isVideoPlayRequested) {
            this.togglePaused(false);
        }
        if (prevProps.isVideoPauseRequested !== isVideoPauseRequested &&
            isVideoPauseRequested) {
            this.togglePaused(true);
        }
        this.toggleLoop(loop);
    };
    YoutubeExternal.prototype.togglePaused = function (paused) {
        if (paused) {
            this.player.pauseVideo();
        }
        else {
            this.player.playVideo();
        }
    };
    YoutubeExternal.prototype.toggleLoop = function (loop) {
        if (loop) {
            var video_id = this.player.getVideoData().video_id;
            // need load playlist to set loop to true
            // but loadPlay list sets video to the beginning
            this.player.loadPlaylist(video_id);
            this.player.setLoop(true);
        }
        else {
            this.player.setLoop(false);
        }
    };
    YoutubeExternal.prototype.toggleMute = function (muted) {
        if (muted) {
            this.player.mute();
        }
        else {
            this.player.unMute();
        }
    };
    YoutubeExternal.prototype.buildUrl = function (_a) {
        var src = _a.src, mobileMode = _a.mobileMode, showControls = _a.showControls, locale = _a.locale;
        var _b = window.location, protocol = _b.protocol, hostname = _b.hostname, port = _b.port;
        var origin = "".concat(protocol, "//").concat(hostname).concat(port ? ':' : '').concat(port);
        var query = {
            enablejsapi: '1',
            hl: locale,
            rel: '0',
            origin: origin,
        };
        if (mobileMode) {
            query.playsinline = '1';
        }
        if (!showControls) {
            query.controls = '0';
        }
        var url = new url_1.default(src);
        // https is required for autoplay
        url.protocol = 'https';
        url.search = query;
        return url.toString();
    };
    YoutubeExternal.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, width = _b.width, height = _b.height, isVideoPauseRequested = _b.isVideoPauseRequested, isVideoPlayRequested = _b.isVideoPlayRequested, isVideoPlaying = _b.isVideoPlaying, isVideoPaused = _b.isVideoPaused, fillAllSpace = _b.fillAllSpace;
        var tabIndex = isVideoPauseRequested ||
            isVideoPlayRequested ||
            isVideoPlaying ||
            isVideoPaused
            ? 0
            : -1;
        return (react_1.default.createElement("iframe", { title: "Youtube", width: width, height: height, frameBorder: "0", allowFullScreen: true, tabIndex: tabIndex, onLoad: this.onIframeLoaded, ref: this.handleIframeRef, className: (0, classnames_1.default)(styles_scss_1.default.iframe, className, (_a = {},
                _a[styles_scss_1.default.fillAllSpace] = fillAllSpace,
                _a)) }));
    };
    YoutubeExternal.propTypes = {
        src: prop_types_1.default.string.isRequired,
        locale: prop_types_1.default.string,
        onPlay: prop_types_1.default.func,
        onPause: prop_types_1.default.func,
        onEnd: prop_types_1.default.func,
        onIframeRef: prop_types_1.default.func.isRequired,
        width: prop_types_1.default.number,
        height: prop_types_1.default.number,
        className: prop_types_1.default.string,
        mobileMode: prop_types_1.default.bool,
        isVideoPlayRequested: prop_types_1.default.bool,
        isVideoPauseRequested: prop_types_1.default.bool,
        isVideoPlaying: prop_types_1.default.bool,
        isVideoPaused: prop_types_1.default.bool,
        fillAllSpace: prop_types_1.default.bool,
        loop: prop_types_1.default.bool,
        muted: prop_types_1.default.bool,
    };
    return YoutubeExternal;
}(react_1.default.Component));
exports.default = YoutubeExternal;
//# sourceMappingURL=youtube.js.map